import { useLoaderData } from "react-router-dom";
import { useEffect, useState } from "react";
import Axios from "axios";
import ReactPlayer from "react-player";

export async function storeLoader({ params }) {
	return params;
}
export default function Store() {
	let props = useLoaderData();
	const [videoExist, setVideoExist] = useState(false);

	useEffect(() => {
		Axios.get("/videos/" + props.name + ".mp4")
			.then((res) => {
				if (res.status === 200) {
					setVideoExist(true);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [props.name]);

	return (
		<div className="w-screen h-screen flex flex-col items-center">
			<div className="h-3/5 aspect-video mt-10">
				{videoExist ? (
					<ReactPlayer
						url={"/videos/" + props.name + ".mp4"}
						playing={true}
						loop={true}
						muted={true}
						width="100%"
						height="100%"
					/>
				) : (
					<h1>Video does not exist</h1>
				)}
			</div>
			<div className="h-2/5 w-full flex flex-col justify-center items-center text-3xl">
				Here is the direction to{" "}
				<span className="font-bold text-5xl">{props.name}</span>
			</div>
		</div>
	);
}
